import * as React from 'react'
import {format} from 'date-fns'
import {type TimeoutIDPolyfill} from '@frontrow/console/src/polyfills'
import {useSafeEffect} from '@freckle/react-hooks'

const DEMO_REFRESH_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

type Props = {
  requestedAt: Date
}

function RequestedPanel(props: Props): React.ReactElement {
  const {requestedAt} = props

  useSafeEffect(() => {
    const timer: TimeoutIDPolyfill = setTimeout(() => {
      window.location.reload()
    }, DEMO_REFRESH_INTERVAL_MS)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <React.Fragment>
      <p>Your demo district: None</p>
      <strong>
        <p>Demo requested {format(requestedAt, 'MM/dd/yyyy h:mm a')}</p>
        <p>Check back in few minutes...</p>
      </strong>
    </React.Fragment>
  )
}

export default RequestedPanel
